import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'UIRadioSelectors',
  props: {
    name: null,
    direction: null,
    options: null,
    value: { type: [String, Boolean, Number] },
    loading: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'input', value: string): void
}), expose: any, slots: any, attrs: any }) {

// To be used with v-model
// Generally v-model requires `modelValue` and `update:modelValue`
// and radio buttons by default use the `change` event
// but in vue 2.7 with composition API, we use `value` and `input` event





return { __sfc: true,emits }
}

})